export default __webpack_public_path__ + "static/media/checkin-hero-right.3a3f5333.png";